
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class AppTerms extends Vue {
  private agreed = false;
  @Prop({
    type: Boolean,
    required: true,
  })
  readonly loginAgreed!: boolean;
  @Prop({
    type: Boolean,
    required: true,
  })
  readonly showTermsInMobile!: boolean;

  @Getter("terms") private terms!: string;

  created() {
    this.$store.dispatch("getTerms");
  }

  @Watch("loginAgreed")
  onValueChanged() {
    this.agreed = this.loginAgreed;
  }

  @Emit("agree")
  agree() {
    return !this.agreed;
  }

  @Emit("closeTerms")
  close() {
    return false;
  }
}
